module.exports = __webpack_public_path__ + "img/logo-428.1d004bb8.png";